import { put, call } from 'redux-saga/effects';
import { omuPointsList,omuPointsSave } from '../../../services/settings/superadmin/omnuPointsService';

import * as types from '../../../actions';

export function* omuPointsListSaga(payload) {
    try {
      const response = yield call(omuPointsList, payload);
      yield put({ type: types.OMNU_POINTS_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.OMNU_POINTS_LIST_ERROR, error });
    }
}

export function* omuPointsSaveSaga(payload) {
  try {
    const response = yield call(omuPointsSave, payload);
    yield put({ type: types.OMNU_POINTS_SAVE_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.OMNU_POINTS_SAVE_ERROR, error });
  }
}

